var map = {
	"./1-198x300.jpg": 6585,
	"./2-257x300.jpg": 846,
	"./3-300x300.jpg": 6649,
	"./4-1-300x189.jpg": 5428,
	"./5-1-300x218.jpg": 5060,
	"./6-1-300x186.jpg": 8941,
	"./7-1-300x225.jpg": 6390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9281;